import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getIdentitiesData = params =>
  axios.get(`${API_HOST}/identities`, { params, withCredentials: true });

export const getGroupIdentitiesData = params =>
  axios.get(`${API_HOST}/identities/groups`, { params, withCredentials: true });

export const addIdentityData = params =>
  axios.post(`${API_HOST}/identities`, params, { withCredentials: true });

export const editIdentityData = (identityId, params) =>
  axios.put(`${API_HOST}/identities/${identityId}`, params, {
    withCredentials: true
  });

export const editIdentityGroupData = (identityId, params) =>
  axios.put(`${API_HOST}/identities/${identityId}/group`, params, {
    withCredentials: true
  });

export const editIdentityStatusData = (identityId, params) =>
  axios.put(`${API_HOST}/identities/${identityId}/status`, params, {
    withCredentials: true
  });

export const editIdentityGroupStatusData = (identityId, params) =>
  axios.put(`${API_HOST}/identities/${identityId}/groupStatus`, params, {
    withCredentials: true
  });

export const getIdentityUserKidData = params =>
  axios.get(`${API_HOST}/gochi-kid/user-kid`, {
    params,
    withCredentials: true
  });

export const editIdentityUserKidStatusData = params =>
  axios.post(`${API_HOST}/gochi-kid/user-kid`, params, {
    withCredentials: true
  });

export const getIdentityUserKidsDetailData = userKidId =>
  axios.get(`${API_HOST}/gochi-kid/user-kid/${userKidId}`, {
    withCredentials: true
  });
